export enum BreadcrumbTitleEnum {
  Empty = '#',
  String = '',
}
